import type {
  AddAnnotationConfig,
  AddTagConfig,
  ManualReviewConfig,
  ManualReviewKind,
  NodeDataUpdateAction,
} from '@onefootprint/request-types/dashboard';
import type { ActionFormData } from '../../playbook-builder.types';

const createActionFormPayload = (formData: ActionFormData) => {
  const visibleActions = formData.visibleActions;
  const updatedNodeData: NodeDataUpdateAction & { raiseManualReview?: ManualReviewConfig } = {
    kind: 'action',
    setDecision: undefined,
    addTags: [],
    addAnnotations: [],
    raiseManualReview: undefined,
    setEntityStatuses: [],
  };

  visibleActions.forEach(actionType => {
    if (actionType === 'setDecision') {
      if (formData.setDecision) {
        updatedNodeData.setDecision = formData.setDecision;
      } else {
        updatedNodeData.setDecision = undefined;
      }
      if (!visibleActions.includes('manualReview')) {
        updatedNodeData.raiseManualReview = undefined;
      }
    } else if (actionType === 'tag') {
      // Each tag entry is either a manual literal value or an expression (`{{ token }}`) selected
      // from the dropdown. Drop entries with no value.
      updatedNodeData.addTags = (formData.addTags ?? [])
        .filter(tag => tag.value.trim() !== '')
        .map(
          (tag): AddTagConfig =>
            tag.source === 'expression'
              ? { kind: 'expression', value: tag.value }
              : { kind: 'manual', value: tag.value.trim() },
        );
    } else if (actionType === 'note') {
      updatedNodeData.addAnnotations = formData.addAnnotations
        ? formData.addAnnotations
            .split(';')
            .map(note => note.trim())
            .filter(Boolean)
            .map(
              (note): AddAnnotationConfig => ({
                note,
                isPinned: false,
              }),
            )
        : [];
    } else if (actionType === 'manualReview') {
      if (formData.raiseManualReview) {
        if (formData.raiseManualReview.startsWith('kind:')) {
          updatedNodeData.raiseManualReview = { kind: formData.raiseManualReview.slice(5) as ManualReviewKind };
        } else {
          updatedNodeData.raiseManualReview = { reviewKindId: formData.raiseManualReview.slice(13) };
        }
      } else {
        updatedNodeData.raiseManualReview = undefined;
      }
      if (!visibleActions.includes('setDecision')) {
        updatedNodeData.setDecision = undefined;
      }
    } else if (actionType === 'setEntityStatus') {
      updatedNodeData.setEntityStatuses = formData.setEntityStatuses;
    }
  });

  if (!visibleActions.includes('setDecision')) {
    updatedNodeData.setDecision = undefined;
  }
  if (!visibleActions.includes('tag')) {
    updatedNodeData.addTags = [];
  }
  if (!visibleActions.includes('note')) {
    updatedNodeData.addAnnotations = [];
  }
  if (!visibleActions.includes('manualReview')) {
    updatedNodeData.raiseManualReview = undefined;
  }
  if (!visibleActions.includes('setEntityStatus')) {
    updatedNodeData.setEntityStatuses = [];
  }

  return updatedNodeData;
};

export default createActionFormPayload;
